import {RedocStandalone} from "redoc";
import React from "react";

export const Autentizace = ()=>  {

  return <div className={'markdown redoc-wp'}>
    <RedocStandalone
      definitionUrl={`/spec/autentizace.yaml`}
      router="history"
      options={{
        scrollYOffset: 65,
        layout: 'stacked',
        showExtensions: false,
        hideDownloadButtons: true,
        jsonSamplesExpandLevel: Infinity,
        schemasExpansionLevel: Infinity,
        routingBasePath: `/autentizace`,
      }}
    />
  </div>
}